import { FontIcon, IStyle, mergeStyles } from '@fluentui/react';
import React from 'react';
import { internal__getLazyImagePlaceholderStyles } from './styles';
import { BwjSpinner } from '../bwj-spinner';

export interface ILazyImagePlaceholderStyles {
    root?: IStyle;
    icon?: IStyle;
}

interface ILazyImagePlaceholderProps {
  icon: string;
  styles?: ILazyImagePlaceholderStyles;
}

export const Internal__LazyImagePlaceholder: React.FunctionComponent<ILazyImagePlaceholderProps> = (props) => {
    const styles = internal__getLazyImagePlaceholderStyles();
    const rootStyle = !!props.styles?.root ? mergeStyles([styles.surface, props.styles.root])  : mergeStyles([styles.surface]);
    const iconStyle = !!props.styles?.icon ? mergeStyles([styles.icon, props.styles.icon])  : mergeStyles([styles.icon]);

    let iconSize = styles.icon.fontSize as string | number;
    if(!!props.styles?.icon) {
      const iconStyles = props.styles.icon as any;
      iconSize = !!iconStyles && !!iconStyles.fontSize ? iconStyles.fontSize as string | number : iconSize;
    }

  return (
    <div className={rootStyle}>
        {props.icon === 'spinner' ? <BwjSpinner size={iconSize} /> :
        <FontIcon iconName={props.icon} className={iconStyle} />}
    </div>
  );
};
